import { IconProps } from "../../../types/style";

const FolderOpenIcon = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.06 11.8201L20.9 11.6001C20.62 11.2601 20.29 10.9901 19.91 10.7901C19.4 10.5001 18.82 10.3501 18.22 10.3501H5.76995C5.16995 10.3501 4.59995 10.5001 4.07995 10.7901C3.68995 11.0001 3.33995 11.2901 3.04995 11.6501C2.47995 12.3801 2.20995 13.2801 2.29995 14.1801L2.66995 18.8501C2.79995 20.2601 2.96995 22.0001 6.13995 22.0001H17.86C21.03 22.0001 21.19 20.2601 21.33 18.8401L21.7 14.1901C21.79 13.3501 21.57 12.5101 21.06 11.8201ZM14.39 17.3401H9.59995C9.20995 17.3401 8.89995 17.0201 8.89995 16.6401C8.89995 16.2601 9.20995 15.9401 9.59995 15.9401H14.39C14.78 15.9401 15.09 16.2601 15.09 16.6401C15.09 17.0301 14.78 17.3401 14.39 17.3401Z"
          fill={color}
        />
        <path
          opacity="0.4"
          d="M3.38 11.31C3.6 11.11 3.82 10.93 4.08 10.79C4.59 10.5 5.17 10.35 5.77 10.35H18.23C18.83 10.35 19.4 10.5 19.92 10.79C20.18 10.93 20.41 11.11 20.62 11.32V10.79V9.82C20.62 6.25 19.53 5.16 15.96 5.16H13.58C13.14 5.16 13.13 5.15 12.87 4.81L11.67 3.2C11.1 2.46 10.65 2 9.22001 2H8.04C4.47 2 3.38 3.09 3.38 6.66V10.8V11.31Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default FolderOpenIcon;
